// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  margin: 0;
}

h5 {
  margin: 1em 0 0.1em;
}

h6 {
  margin: 0.4em 0 0.1em;
}

.margin-overall {
  padding: 0 3em !important;
}

.margin-top-large {
  margin: 0.6em 0 0.3em;
}

.margin-top-small {
  margin: 0.6em 0 0.1em;
}

.center {
  text-align: center;
}

.bottom {
  padding-bottom: 2em !important;
}

ion-grid {
  margin: 0px;
  padding: 0px;
}
@media screen and (max-width: 576px) {
  ion-grid {
    padding: 0 5px;
  }
}

.col-header-left {
  display: flex;
  justify-content: left !important;
}

.col-header-center {
  display: flex;
  justify-content: center !important;
}

.col-content {
  padding-top: 0px;
}

.row-terms {
  margin-top: 5px;
}
@media screen and (min-width: 576px) {
  .row-terms {
    margin-left: 12px;
  }
}

.row-restricted {
  margin-top: 15px;
}

.progress-bar-container {
  margin-top: 10px;
  height: 36px;
  border-right-width: 0;
}
.progress-bar-container .progress-bar-background {
  width: 100%;
  background-color: #eeeeee;
  border: solid 1px #d0d0d0;
}
.progress-bar-container .progress-bar {
  width: 0%;
  height: 36px;
  background-image: linear-gradient(to bottom, #ff990b, #ffd40b);
}
.progress-bar-container .progress-bar-label {
  position: relative;
  font-size: x-large;
  font-weight: bold;
  top: -36px;
  color: #000000;
  width: 100%;
  line-height: 36px;
  /* To center it vertically */
  text-align: center;
}

.tabular-data ion-row ion-col {
  padding: 15px 7px;
}

.bonus-detail-sub {
  margin: 2.5%;
  border: 1px solid frey;
}

.forfeit-button ion-button {
  --background: red;
}

@media screen and (max-width: 576px) {
  .btn-hg {
    font-size: 14px;
    height: 40px;
    width: 100%;
  }
}

.bold-text {
  font-weight: 900;
}

.column-name {
  padding-bottom: 10px;
}

.play-button {
  width: 200px;
  margin: 10px auto;
  display: block;
}

.go-to-promo {
  text-decoration: underline;
  padding-top: 15px;
  text-align: center;
}

.bonus-details-more-section {
  justify-content: center;
  margin-top: 30px;
}
.bonus-details-more-section .more-button {
  width: 165px;
  margin: auto;
  background: none;
}

.available-games-label {
  font-weight: 900;
  margin-bottom: 10px;
  padding-left: 15px;
}

.games-list {
  padding-top: 10px;
  padding-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rewards/bonuses/bonus-details/bonus-details.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;AACE;EAJF;IAKI,cAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,gCAAA;AAEF;;AACA;EACE,aAAA;EACA,kCAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,eAAA;AAEF;AADE;EAFF;IAGI,iBAAA;EAIF;AACF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,gBAAA;EACA,YAAA;EACA,qBAAA;AAIF;AAFE;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;AAIJ;AADE;EACE,SAAA;EACA,YAAA;EACA,8DAAA;AAGJ;AAAE;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;AAEJ;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,sBAAA;AACF;;AAEE;EACE,iBAAA;AACJ;;AAGE;EADF;IAEI,eAAA;IACA,YAAA;IACA,WAAA;EACF;AACF;;AACA;EACE,gBAAA;AAEF;;AAAA;EACE,oBAAA;AAGF;;AADA;EACE,YAAA;EACA,iBAAA;EACA,cAAA;AAIF;;AAFA;EACE,0BAAA;EACA,iBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,uBAAA;EACA,gBAAA;AAMF;AALE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAOJ;;AAJA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAOF;;AALA;EACE,iBAAA;EACA,kBAAA;AAQF","sourcesContent":["p {\r\n  margin: 0;\r\n}\r\n\r\nh5 {\r\n  margin: 1em 0 0.1em;\r\n}\r\n\r\nh6 {\r\n  margin: 0.4em 0 0.1em;\r\n}\r\n\r\n.margin-overall {\r\n  padding: 0 3em !important;\r\n}\r\n\r\n.margin-top-large {\r\n  margin: 0.6em 0 0.3em;\r\n}\r\n\r\n.margin-top-small {\r\n  margin: 0.6em 0 0.1em;\r\n}\r\n\r\n.center {\r\n  text-align: center;\r\n}\r\n\r\n.bottom {\r\n  padding-bottom: 2em !important;\r\n}\r\n\r\nion-grid {\r\n  margin: 0px;\r\n  padding: 0px;\r\n\r\n  @media screen and (max-width: 576px) {\r\n    padding: 0 5px;\r\n  }\r\n}\r\n\r\n.col-header-left {\r\n  display: flex;\r\n  justify-content: left !important;\r\n}\r\n\r\n.col-header-center {\r\n  display: flex;\r\n  justify-content: center !important;\r\n}\r\n\r\n.col-content {\r\n  padding-top: 0px;\r\n}\r\n\r\n.row-terms {\r\n  margin-top: 5px;\r\n  @media screen and (min-width: 576px) {\r\n    margin-left: 12px;\r\n  }\r\n}\r\n\r\n.row-restricted {\r\n  margin-top: 15px;\r\n}\r\n\r\n.progress-bar-container {\r\n  margin-top: 10px;\r\n  height: 36px;\r\n  border-right-width: 0;\r\n\r\n  .progress-bar-background {\r\n    width: 100%;\r\n    background-color: #eeeeee;\r\n    border: solid 1px #d0d0d0;\r\n  }\r\n\r\n  .progress-bar {\r\n    width: 00%;\r\n    height: 36px;\r\n    background-image: linear-gradient(to bottom, #ff990b, #ffd40b);\r\n  }\r\n\r\n  .progress-bar-label {\r\n    position: relative;\r\n    font-size: x-large;\r\n    font-weight: bold;\r\n    top: -36px;\r\n    color: #000000;\r\n    width: 100%;\r\n    line-height: 36px;\r\n    /* To center it vertically */\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.tabular-data ion-row ion-col {\r\n  padding: 15px 7px;\r\n}\r\n\r\n.bonus-detail-sub {\r\n  margin: 2.5%;\r\n  border: 1px solid frey\r\n}\r\n.forfeit-button {\r\n  ion-button {\r\n    --background: red;\r\n  }\r\n}\r\n.btn-hg {\r\n  @media screen and (max-width: 576px) {\r\n    font-size: 14px;\r\n    height: 40px;\r\n    width: 100%;\r\n  }\r\n}\r\n.bold-text {\r\n  font-weight: 900;\r\n}\r\n.column-name {\r\n  padding-bottom: 10px;\r\n}\r\n.play-button {\r\n  width: 200px;\r\n  margin: 10px auto;\r\n  display: block;\r\n}\r\n.go-to-promo {\r\n  text-decoration: underline;\r\n  padding-top: 15px;\r\n  text-align: center;\r\n}\r\n.bonus-details-more-section {\r\n  justify-content: center;\r\n  margin-top: 30px;\r\n  .more-button {\r\n    width: 165px;\r\n    margin: auto;\r\n    background: none;\r\n  }\r\n}\r\n.available-games-label {\r\n  font-weight: 900;\r\n  margin-bottom: 10px;\r\n  padding-left: 15px;\r\n}\r\n.games-list {\r\n  padding-top:10px;\r\n  padding-left: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
